









































































































































































































import {
  Component,
  Prop,
  Vue,
  Watch,
} from 'vue-property-decorator';
import IntegrationsService from '../services/integrations.service';
import {
  Integration,
  IntegrationOutputType,
  WebhookChannelDetails,
  OpsGenieChannelDetails,
  EmailChannelDetails,
  MySQLChannelDetails,
  S3BucketChannelDetails,
  TestResult,
  WebsocketChannelDetails,
  AzureDataLakeChannelDetails,
  SFTPChannelDetails, QSS3ChannelDetails,
} from '@/types';
import { Action, Getter } from 'vuex-class';
import IntegrationIcon from '@/components/IntegrationIcon.vue';
import MQTTIntegration from '@/components/publish/integrations/MQTTIntegration.vue';
import WebsocketIntegration from '@/components/publish/integrations/WebsocketIntegration.vue';
import NodeRedIntegration from '@/components/publish/integrations/NodeRedIntegration.vue';
import S3BucketIntegration from '@/components/publish/integrations/S3BucketIntegration.vue';
import MySQLIntegration from '@/components/publish/integrations/MySQLIntegration.vue';
import WebhookIntegration from '@/components/publish/integrations/WebhookIntegration.vue';
import EmailIntegration from '@/components/publish/integrations/EmailIntegration.vue';
import URLIntegration from '@/components/publish/integrations/URLIntegration.vue';
import OpsGenieIntegration from './publish/integrations/OpsGenieIntegration.vue';
import AzureDataLakeIntegration from '@/components/publish/integrations/AzureDataLakeIntegration.vue';
import SFTPIntegration from '@/components/publish/integrations/SFTPIntegration.vue';
import QuicksightS3Integration from '@/components/publish/integrations/QuicksightS3Integration.vue';
import BACnetIntegration from '@/components/publish/integrations/BACnetIntegration.vue';
import CancelButton from '@/components/CancelButton.vue';
import ConfirmButton from '@/components/ConfirmButton.vue';
import EventBus from '@/services/eventbus.service';

export enum IntegrationsEditSteps {
  SelectType = 1,
  EditDetails = 2,
}
const PAYLOAD_VERSION_TYPES = ['slack', 'webhook', 'mqtt', 'awsiot', 'websocket'];

@Component({
  components: {
    ConfirmButton,
    CancelButton,
    QuicksightS3Integration,
    SFTPIntegration,
    MQTTIntegration,
    WebsocketIntegration,
    NodeRedIntegration,
    S3BucketIntegration,
    AzureDataLakeIntegration,
    MySQLIntegration,
    WebhookIntegration,
    EmailIntegration,
    URLIntegration,
    OpsGenieIntegration,
    IntegrationIcon,
    BACnetIntegration,
  },
})
export default class IntegrationsEdit extends Vue {
  private readonly IntegrationsEditSteps = IntegrationsEditSteps;
  private readonly IntegrationOutputType = IntegrationOutputType;
  @Prop({default: []}) private integrations!: Integration[];
  @Prop() private integration!: Integration;
  @Prop({default: undefined}) private testResult!: TestResult | undefined;
  @Prop({default: () => [] }) private types!: object[];
  @Prop({ default: IntegrationOutputType.STREAMING }) private outputType!: IntegrationOutputType;

  @Getter private hasPermission: any;
  @Action private addToastErrorMessage: any;

  private step: IntegrationsEditSteps = IntegrationsEditSteps.SelectType;
  private isSaving: boolean = false;
  private localResult: TestResult | null = {success: false, message: ''};
  private isTestInProgress: boolean = false;
  private validFlag: boolean = true;
  private nameError: boolean = false;

  private savedPayloadVersion: number | null = null;
  private showVersionChangeWarning: boolean = false;
  private readonly payloadVersionOptions = [
    { label: 'Version 1', value: 1 },
    { label: 'Version 2', value: 2 },
  ];

  private beforeMount() {
    if (this.editing) {
      this.step = IntegrationsEditSteps.EditDetails;
    }
    this.savedPayloadVersion = this.integration.payload_version || null;
  }

  private get supportsPayloadVersion(): boolean {
    return PAYLOAD_VERSION_TYPES.includes(this.integration.type);
  }

  private cancelVersionChange() {
    this.showVersionChangeWarning = false;
    this.$emit('update:integration', { ...this.integration, payload_version: this.savedPayloadVersion });
  }

  private confirmVersionChange() {
    this.showVersionChangeWarning = false;
    this.performSave();
  }

  private get hasHeaders() {
    return this.integration.type === 'webhook';
  }

  private get hasUrl() {
    return this.integration.type === 'slack' || this.integration.type === 'webhook' || this.integration.type === 'opsgenie';
  }

  private get isEmail() {
    return this.integration.type === 'email';
  }

  private get isOpsGenie() {
    return this.integration.type === 'opsgenie';
  }

  private get isMQTT() {
    return this.integration.type === 'mqtt';
  }

  private get isWebsocket() {
    return this.integration.type === 'websocket';
  }

  private get isAwsIot() {
    return this.integration.type === 'awsiot';
  }

  private get isAwsS3() {
    return this.integration.type === 's3';
  }
  private get isQSS3() {
    return this.integration.type === 'qss3';
  }
  private get isAzureDataLake() {
    return this.integration.type === 'azureDataLake';
  }
  private get isSFTP() {
    return this.integration.type === 'sftp';
  }
  private get isMySQL() {
    return this.integration.type === 'mysql-database';
  }
  private get isBACnet() {
    return this.integration.type === 'bacnet';
  }

  private setChannelDetail(key: string, value: any) {
    if (!this.integration.channel_details) {
      return;
    }

    this.$emit('update:integration', { ...this.integration, channel_details: {  ...this.integration.channel_details, [key]: value }});
  }

  private saveIntegration() {
    if (this.editing && this.savedPayloadVersion !== null && this.integration.payload_version !== this.savedPayloadVersion) {
      this.showVersionChangeWarning = true;
      return;
    }
    this.performSave();
  }

  private async performSave() {
    this.isSaving = true;
    try {
      if (!this.editing) {
        await IntegrationsService.createIntegration(this.integration);
        EventBus.$emit('showGenericSnackbar', {text: 'The integration was created successfully.', icon: 'mdi-content-save'});
      } else {
        await IntegrationsService.updateIntegration(this.integration);
        this.localResult = null;
        EventBus.$emit('showGenericSnackbar', {text: 'The integration was saved successfully.', icon: 'mdi-content-save'});
      }
    } finally {
      this.isSaving = false;
      this.savedPayloadVersion = this.integration.payload_version || null;
      this.$emit('update:integrations');
    }
  }

  private async testIntegration() {
    if (this.isTestInProgress) {
      return;
    }

    const { id } = this.integration;
    if (id) {
      try {
        this.isTestInProgress = true;
        this.localResult = await IntegrationsService.testIntegration(id);
      } finally {
        this.isTestInProgress = false;
      }
    }
  }

  private goBack() {
    this.step = IntegrationsEditSteps.SelectType;
    this.localResult = null;
  }

  private closeDrawer() {
    this.$emit('closeAccordion');
    this.step = IntegrationsEditSteps.SelectType;
    this.localResult = null;
  }

  private get isChannelValid(): boolean {
    const channelDetails = this.integration.channel_details;
    switch (this.integration.type) {
      // case 'mqtt': {
      //   const details = channelDetails as MQTTChannelDetails;
      //   console.log(details.endpoint, details.topic, !!details.endpoint, !!details.topic)
      //   return !!details.endpoint && !!details.topic;
      // }
      case 'websocket':
      case 'awsiot':
      case 'bacnet': {
        const details = channelDetails as WebsocketChannelDetails;
        return !!details.token;
      }
      case 's3': {
        const details = channelDetails as S3BucketChannelDetails;
        return !!details.region && !!details.bucketName && ((!!details.secretAccessKey && !!details.accessKeyId) || (!!details.roleARN && !!details.externalId ));
      }
      case 'qss3': {
        const details = channelDetails as QSS3ChannelDetails;
        return !!details.region && !!details.bucketName && ((!!details.secretAccessKey && !!details.accessKeyId) || (!!details.roleARN && !!details.externalId ));
      }
      case 'mysql': {
        const details = channelDetails as MySQLChannelDetails;
        return !!details.host && !!details.port && !!details.database && !!details.username;
      }
      case 'webhook': {
        const details = channelDetails as WebhookChannelDetails;
        return !!details.url;
      }
      case 'opsgenie': {
        const details = channelDetails as OpsGenieChannelDetails;
        return !!details.url && !!details.authKey;
      }
      case 'email': {
        const details = channelDetails as EmailChannelDetails;
        return !!details.address;
      }
      case 'azureDataLake': {
        const details = channelDetails as AzureDataLakeChannelDetails;
        return !!details.containerName && !!details.accountName && (!!details.token || !!details.accountKey);
      }
      case 'sftp': {
        const details = channelDetails as SFTPChannelDetails;
        return !!details.host && !!details.port && !!details.username && (!!details.password || !!details.privateKey);
      }
      default: return true;
    }
  }

  private get nameRules() {
    const rules: any[] = [];
    rules.push(
      (v: string) => !!v || 'Integration name is required',
      (v: string) => {
        if (v.length && this.integrations.filter((n) => n.name.toLowerCase() === v.toLowerCase()).length > 1) {
          this.nameError = true;
          return `Name "${v}" already exists`;
        } else {
          this.nameError = false;
          return true;
        }
      },
    );
    return rules;

  }

  private get editing(): boolean {
    return !!this.integration.id;
  }

  private setIntegrationType(type: string) {
    const payloadVersion = PAYLOAD_VERSION_TYPES.includes(type) ? 2 : undefined;
    switch (type) {
      case 'email': {
        this.$emit('update:integration', {...this.integration, type, channel_details: {
          address: '',
        }});
        break;
      }
      case 'webhook': {
        this.$emit('update:integration', {...this.integration, type, payload_version: payloadVersion, channel_details: {
          url: '',
          headers: {},
        }});
        break;
      }
      case 'slack': {
        this.$emit('update:integration', {...this.integration, type, payload_version: payloadVersion, channel_details: {
          url: '',
        }});
        break;
      }
      case 'opsgenie': {
        this.$emit('update:integration', {...this.integration, type, channel_details: {
          url: '',
          authKey: '',
        }});
        break;
      }
      case 'mqtt': {
        this.$emit('update:integration', {...this.integration, type, payload_version: payloadVersion, channel_details: {
          endpoint: '',
          username: '',
          password: '',
          clientId: '',
          topic: '',
        }});
        break;
      }
      case 'websocket': {
        this.$emit('update:integration', {...this.integration, type, payload_version: payloadVersion, channel_details: {
          token: '',
          endpoint: '',
        }});
        break;
      }
      case 'awsiot': {
        this.$emit('update:integration', {...this.integration, type, payload_version: payloadVersion, channel_details: {
          token: '',
        }});
        break;
      }
      case 's3': {
        this.$emit('update:integration', {...this.integration, type, channel_details: {
          region: '',
          bucketName: '',
          accessKeyId: '',
          secretAccessKey: '', // TODO: ENCRYPT
        }});
        break;
      }
      case 'qss3': {
        this.$emit('update:integration', {...this.integration, type, channel_details: {
          region: '',
          bucketName: '',
          accessKeyId: '',
          secretAccessKey: '', // TODO: ENCRYPT
        }});
        break;
      }
      case 'azureDataLake': {
        this.$emit('update:integration', {...this.integration, type, channel_details: {
          token: '',
          containerName: '',
          accountName: '',
          accountKey: '', // TODO: ENCRYPT
        }});
        break;
      }
      case 'sftp': {
        this.$emit('update:integration', {...this.integration, type, channel_details: {
            host: '',
            username: '',
            password: '',
            port: 0,
          }});
        break;
      }
      case 'bacnet': {
        this.$emit('update:integration', {...this.integration, type, channel_details: {
          token: '',
        }});
        break;
      }
    }

    this.step = IntegrationsEditSteps.EditDetails;
  }

  @Watch('testResult', {immediate: true})
  private onTestResultChange(result: TestResult) {
    if (result) {
      Vue.set(this, 'localResult', this.testResult);
    }
  }
}
